import React from 'react';
import { Field } from 'formik';
import { Fields, Checkbox } from 'modules/af_cm_ui_kit/components';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_QUESTIONS } from '../Form/Form.types';
import { Props } from './CurrentIncome.types';
import { RelatedToEmployedGrossSalary, RelatedToSelfEmployedIncome } from '../../partials';

const Current: React.FC<Props> = ({ prefix, buisinessTypes }) => {
  const otherIncomeFieldName = (field: FIELDS): string => {
    return `${prefix}.${FIELDS.OTHER_INCOME_PREFIX}.${field}`;
  };

  return (
    <>
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.EMPLOYED_GROSS_SALARY}
        name={`${prefix}.${FIELDS.EMPLOYED_GROSS_SALARY}`}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <RelatedToEmployedGrossSalary prefix={prefix} />

      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.SELF_EMPLOYED_SALARY}
        name={`${prefix}.${FIELDS.SELF_EMPLOYED_SALARY}`}
        variant={VARIANTS_TYPES.CURRENCY}
      />
      <Field
        component={Fields.Select}
        title={FIELDS_QUESTIONS.BUSINESS_TYPE}
        name={`${prefix}.${FIELDS.BUSINESS_TYPE}`}
        options={buisinessTypes}
      />

      <RelatedToSelfEmployedIncome prefix={prefix} />

      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.INVESTMENT_AND_SAVINGS}
        name={otherIncomeFieldName(FIELDS.INVESTMENT_AND_SAVINGS)}
        variant={VARIANTS_TYPES.CURRENCY}
      />
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.RENTAL_INCOME}
        name={otherIncomeFieldName(FIELDS.RENTAL_INCOME)}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.FOSTERING_INCOME}
        name={otherIncomeFieldName(FIELDS.FOSTERING_INCOME)}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.MAINTENANCE_INCOME}
        name={otherIncomeFieldName(FIELDS.MAINTENANCE_INCOME)}
        variant={VARIANTS_TYPES.CURRENCY}
        extraContent={[
          {
            position: 'bottom',
            variant: 'component',
            content: (
              <Field
                component={Checkbox}
                title={'Guaranteed'}
                name={otherIncomeFieldName(FIELDS.GUARANTEED_MAINTENANCE)}
              />
            ),
          },
        ]}
      />

      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.BENEFIT_INCOME}
        name={otherIncomeFieldName(FIELDS.BENEFIT_INCOME)}
        variant={VARIANTS_TYPES.CURRENCY}
        extraContent={[
          {
            position: 'bottom',
            variant: 'component',
            content: (
              <Field component={Checkbox} title={'Guaranteed'} name={otherIncomeFieldName(FIELDS.GUARANTEED_BENEFIT)} />
            ),
          },
        ]}
      />
    </>
  );
};

export default Current;
